import * as mapStyles from '../view/MapVectorStyles';

// ΔVΔVΔ: Blue Green Yellow colors
var colorPalletA = { none: mapStyles.canvasHatchPattern, low: 'rgba(255, 255, 204, .7)', med: 'rgba(161, 218, 180, .7)', high: 'rgba(65, 182, 196, .7)', top: 'rgba(34, 94, 168, .7)' };
// ΔVΔVΔ: Greens
var colorPalletB = { none: mapStyles.canvasHatchPattern, low: 'rgba(237, 248, 233, .7)', med: 'rgba(186, 228, 179, .7)', high: 'rgba(116, 196, 118, .7)', top: 'rgba(35, 139, 69 , .7)' };
// ΔVΔVΔ: Oranges
var colorPalletC = { none: mapStyles.canvasHatchPattern, low: 'rgba(255, 255, 212, .7)', med: 'rgba(254, 217, 142, .7)', high: 'rgba(254, 153, 41, .7)', top: 'rgba(204, 72, 2 , .7)' };
// ΔVΔVΔ: Purples
var colorPalletD = { none: mapStyles.canvasHatchPattern, low: 'rgba(242, 240, 247, .7)', med: 'rgba(203, 201, 226, .7)', high: 'rgba(158, 154, 200, .7)', top: 'rgba(106, 81, 163, .7)' };
// ΔVΔVΔ: Blues
var colorPalletE = { none: mapStyles.canvasHatchPattern, low: 'rgba(239, 243, 255, .7)', med: 'rgba(189, 215, 231, .7)', high: 'rgba(107, 174, 214, .7)', top: 'rgba(33, 113, 181, .7)' };

//Convert A hex, rgb, or pattern value to a open layers style
// const flatColorStyle = (color) => {
//     return new Style({
//         fill: new Fill({ color }),
//         stroke: new Stroke({ color: "#000" }),
//     });
// };

//Convert each Theme attribute to an open layers style
const colorSchemeToStyle = (scheme) => {
    Object.keys(scheme).forEach((key) => {
        let color = scheme[key];
        scheme[key] = mapStyles.flatColorStyle(color);
        scheme[key + '_county'] = mapStyles.flatColorCountyStyle(color);
        scheme[key + '_low'] = mapStyles.flatColorStyle(color, true);
        scheme[key + '_low_county'] = mapStyles.flatColorCountyStyle(color, true);
        scheme[key + '_hover'] = mapStyles.flatColorHoverStyle(color);
    });
    return scheme;
};

const colorSchemeA = colorSchemeToStyle({ ...colorPalletA });
const colorSchemeB = colorSchemeToStyle({ ...colorPalletB });
const colorSchemeC = colorSchemeToStyle({ ...colorPalletC });
const colorSchemeD = colorSchemeToStyle({ ...colorPalletD });
const colorSchemeE = colorSchemeToStyle({ ...colorPalletE });

// const noDataStyle = flatColorStyle(mapStyles.canvasHatchPattern);
// var undefinedAreaColorScheme = flatColorStyle("#cccccc");

// ΔVΔVΔ: Global themes
const sviThemes = [
    { id: 0, xicon: 'globe', label: 'Overall SVI', labelPast: 'Overall SVI', label2020: 'Overall SVI', slug: 'overall_svi', colorPallet: colorPalletA, colorScheme: colorSchemeA, dataNames: [''] },
    { id: 1, xicon: 'building', label: 'Socioeconomic Status', labelPast: 'Socioeconomic Status', label2020: 'Socioeconomic Status', slug: 'socioeconomic_status', colorPallet: colorPalletB, colorScheme: colorSchemeB, dataNames: [''] },
    { id: 2, xicon: 'house', label: 'Household Composition & Disability', labelPast: 'Household Composition & Disability', label2020: 'Household Characteristics', slug: 'household_composition_disability', colorPallet: colorPalletC, colorScheme: colorSchemeC, dataNames: [''] },
    { id: 3, xicon: 'language', label: 'Minority Status & Language', labelPast: 'Minority Status & Language', label2020: 'Racial & Ethnic Minority Status', slug: 'minority_status_language', colorPallet: colorPalletD, colorScheme: colorSchemeD, dataNames: [''] },
    { id: 4, xicon: 'car', label: 'Housing Type & Transportation', labelPast: 'Housing Type & Transportation', label2020: 'Housing Type & Transportation', slug: 'housing_rype_transportation', colorPallet: colorPalletE, colorScheme: colorSchemeE, dataNames: [''] }
];

export { sviThemes };
